import { draftDA } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getDraftDAList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(draftDA.draftDABase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getDraftDAObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftDA.draftDABase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getChartSummary(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftDA.draftDABase}chart_summary/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  cancelDraftDA(id, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${draftDA.draftDABase}${id}/cancel/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  bulkCancelDraftDA(payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${draftDA.draftDABase}bulk_cancel/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getBulkUpdateReasons(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftDA.draftDABase}bulk_update_reasons/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getBulkUpdateRows(reason, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftDA.draftDABase}bulk_update_rows/`, { params: { reason, ...params } })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  bulkUpdateDraftDA(payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${draftDA.draftDABase}bulk_update/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  exportForFix(reason) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftDA.draftDABase}export_for_fix/`, {
          params: { reason },
          responseType: "blob",
        })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  bulkFixUpload(payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${draftDA.draftDABase}bulk_fix_upload/`, payload)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
